// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-task-wrapper[data-v-58c17c02] {\n  margin-left: 9px;\n  margin-right: 4px;\n}\n.addtask-icon[data-v-58c17c02] {\n  margin-top: 3px;\n}", ""]);
// Exports
module.exports = exports;
